import StatsList from "./list";

const statsComponents = {
  list: StatsList,
};

export default statsComponents;
